import { IntlShape } from 'react-intl';
import {
  getIntlCasinoFiltersEvenMoreKwiffmasSlotsTextKey,
  getIntlCasinoFiltersHappyKwiffentinesTextKey,
  getIntlCasinoFiltersItIsKwiffmasTextKey,
  getIntlCasinoFiltersKwiffmasTextKey,
  getIntlCasinoFiltersKwiffoweenTextKey,
} from '../internationalUtils';

export enum CASINO_FILTER_NAME {
  KWIFF_PICKS = 'kwiff picks',
  HOME_MOST_POPULAR = 'home most popular',
  MOST_POPULAR = 'most popular',
  ALL_SLOTS = 'All slots',
  ALL_TABLE_GAMES = 'All table games',
  ALL_LIVE_CASINO_GAMES = 'All Live Casino Games',
  WE_HAVE_GOT_JACKPOT_MAD = "We've gone Jackpot Mad!",
  NEW_GAMES_WE_LOVE = 'New Games We Love',
  NEW_AT_KWIFF = 'New@kwiff',
  SCHEDULED = 'Scheduled',
  INSTANT = 'Instant',
  SPORTS = 'Sports',
  IT_IS_KWIFFMAS = "It's kwiffmas",
  MEGAWAYS_SLOTS = 'Megaways™ Slots',
  EASTER = 'Easter',
  IT_IS_SHOW_TIME = "It's Show Time!",
  FANCY_THE_KWIFF_EXPERIENCE = 'Fancy the kwiff experience?',
  NEW_AT_KWIFF_LIVE_CASINO = 'New @ kwiff Live Casino',
  SCRATCH_AND_REVEAL = 'Scratch & Reveal',
  IT_IS_A_JUNGLE_VIBE = "It's a Jungle Vibe!",
  VIRTUAL_FOOTBALL = 'Virtual Football',
  NO_LIMIT_WORLD = 'No Limit World',
  MEGA_DROPS = 'Mega Drops™',
  NEW_GAMES = 'New Games',
  FEATURED_STUDIO = 'Featured Studio',
  EVEN_MORE_KWIFFMAS_SLOTS = 'Even More kwiffmas Slots!',
  KWIFFMAS = 'kwiffmas',
  PROGRESSIVE_JACKPOTS = 'Progressive Jackpots',
  THUNDERKICKS_FINEST = "Thunderkick's finest",
  SCRATCHCARDS = 'Scratchcards',
  LIVE_CASINO = 'Live Casino',
  TABLE_GAMES = 'Table Games',
  GAME_SHOWS = 'Game Shows',
  KWIFFS_JOKERS = "kwiff's Jokers",
  VIKING_RAIDERS = 'Viking Raiders',
  ALL_VIRTUAL_SPORTS = 'All Virtual Sports',
  LIVE_ON_THE_WILD_SIDE = 'Live on the Wild Side',
  CLASSIC_SLOTS = 'Classic Slots',
  THE_LUCKY_ORCHARD = 'The Lucky Orchard',
  OUT_OF_THE_WORLD_SLOTS = 'Out of this World Slots',
  MAGICAL_SLOTS = 'Magical Slots',
  ANCIENT_EGYPT = 'Ancient Egypt',
  ANIMAL_SLOTS = 'Animal Slots',
  ADVENTURE_SLOTS = 'Adventure Slots',
  SLOTS_FROM_BEYOND_THE_GREAT_WALL = 'Slots from beyond the Great Wall',
  THE_FAR_EAST = 'The Far East',
  CITY_SLOTS = 'City Slots',
  MONSTERS_UNLEASHED = 'Monsters Unleashed',
  MEDIEVAL_SLOTS = 'Medieval Slots',
  MAGICAL_CREATURES = 'Magical Creatures',
  CHRISTMAS_DAILY_FREE_SPIN_TOURNAMENT = 'Christmas Daily Free Spin Tournament',
  THE_BIG_SCREEN = 'The Big Screen',
  MYTHICAL_CREATURES = 'Mythical Creatures',
  HEROES_AND_VILLAINS = 'Heroes and Villains',
  XMAS_TOURNAMENT = 'Xmas Tournament',
  TWENTY_TWENTYONE_PRIZE_DROP = '2021 Prize Drop',
  A_THOUSAND_POUNDS_MULTIGAME_TOURNAMENT = '£1,000 Multi-Game Tournament',
  MEGAWAYS = 'Megaways',
  HEATING_UP_WINTER = 'Heating Up Winter',
  HAPPY_KWIFFENTINES = 'Happy kwiffentines!',
  HAPPY_CHINESE_NEW_YEAR_EXCLAMATION = 'Happy Chinese New Year!',
  ST_PATRICKS_DAY_SLOTS = 'St Patricks Day Slots',
  CHELTENHAM = 'Cheltenham!',
  WEEKLY_TOURNAMENT = 'Weekly Tournament',
  WOWPOT = 'Wowpot',
  MEGA_MOOLAH = 'Mega Moolah',
  WEEKLY_MULTI_GAME_TOURNAMENT = 'Weekly Multi Game Tournament',
  REELERCOASTER = 'Reelercoaster',
  KWIFFOWEEN = 'kwiffoween',
  ROULETTE = 'Roulette',
  BLACKJACK = 'Blackjack',
  POKER = 'Poker',
  BACCARAT = 'Baccarat',
  GOLDEN_GAMES = 'Golden Games',
  MULTI_HAND_GAMES = 'Multi Hand Games',
  EUROPEAN_GAMES = 'European Games',
  FIVE_CARD_DRAW = 'Five Card Draw',
  AMERICAN_TABLES = 'American Tables',
  VEGAS_GAMES = 'Vegas Games',
  FIRST_PERSON_GAMES = 'First Person Games',
  TABLES_FROM_AROUND_THE_WORLD = 'Tables From Around The World',
  SPEED_BLACKJACK = 'Speed Blackjack',
  CLASSIC_BLACKJACK = 'Classic Blackjack',
  DELUXE_TABLES = 'Deluxe Tables',
  VIP_TABLES = 'VIP Tables',
  BLACKJACK_SILVER = 'Blackjack Silver',
  SALON_PRIVE = 'Salon Privé',
  VIRTUAL_RACING = 'Virtual Racing',
  DIAMONDS_ARE_FOREVER = 'Diamonds are Forever',
  CLOWNING_AROUND = 'Clowning Around',
  HIGH_SOCIETY = 'High Society',
  GOLDEN_SLOTS = 'Golden Slots',
  ANCIENT_BOOKS = 'Ancient Books',
  MYTHS_AND_LEGENDS = 'Myths and Legends',
  KINGS_AND_QUEENS = 'Kings and Queens',
  THE_AMERICAS = 'The Americas',
  SLOT_FAIRIES = 'Slot Fairies',
  THE_RANCH = 'The Ranch',
  NEON_LIGHTS = 'NEON Lights',
  RICHES = 'Riches',
  TURN_IT_UP = 'Turn it up!',
  DIVINE_REWARDS = 'Divine Rewards',
  WHAT_IS_ON_TONINGHT = "What's on tonight?",
  THE_WITCHES = 'The Witches',
  KWIFFS_LIBRARY = "Kwiff's Library",
  POWERFUL_WOMEN = 'Powerful Women',
  DEEP_IN_THE_FOREST = 'Deep in the Forest',
  WILD_WEST = 'Wild West',
  ITALIAN_SLOTS = 'Italian Slots',
  THE_ROMANS = 'The Romans',
  IRISH_SLOTS = 'Irish Slots',
  MEXICAN_SLOTS = 'Mexican Slots',
  ISLAND_SLOTS = 'Island Slots',
  BEACH_SLOTS = 'Beach Slots',
  SUMMER_SLOTS = 'Summer Slots',
  FAIRYTALE_SLOTS = 'Fairytale Slots',
  BEST_OF_HACKSAW = 'Best of Hacksaw',
  FUTURISTIC_SLOTS = 'Futuristic Slots',
  PACIFIC_SLOTS = 'Pacific Slots',
  MYSTERY_SLOTS = 'Mystery Slots',
  WINTER_SLOTS = 'Winter Slots',
  COPS_AND_ROBBERS = 'Cops and Robbers',
  PIRATE_SLOTS = 'Pirate Slots',
  ON_SAFARI = 'On Safari',
  DEEP_SEA_SLOTS = 'Deep Sea Slots',
  JEWELS = 'Jewels',
  ANCIENT_GREEKS = 'Ancient Greeks',
  PRECIOUS_STONES = 'Precious Stones',
  SWEET_SLOTS = 'Sweet Slots',
  DEMONS = 'Demons',
  THE_DEAD_RISING = 'The Dead Rising',
  COLD_HARD_CASH = 'Cold Hard Cash!',
  PRINCESSES = 'Princesses',
  FEELING_LUCKY = 'Feeling Lucky?',
  TREASURE = 'Treasure',
  FROZEN_WASTELAND = 'Frozen Wasteland',
  ON_THE_FARM = 'On the Farm!',
  THE_WOLF_PACK = 'The Wolf Pack',
  VAMPIRES = 'Vampires',
  STORMS_BREWING = 'Storms Brewing',
  KWIFFS_TOP_TABLES = "kwiff's Top Tables",
  MEGA_BALL = 'Mega Ball',
  HAPPY_CHINESE_NEW_YEAR = 'Happy Chinese New Year',
  INFINITY_REELS = 'Infinity Reels',
  SCRATCH_CARDS = 'Scratch Cards',
  BLACK_JACK = 'BlackJack',
  RECENTLY_PLAYED = 'recently played',
  NEW = 'New',
  DROPS_WINS = 'Drops & Wins',
}

export const translateCasinoFilter = (filterName: string, intl: IntlShape, domain: string) => {
  switch (filterName) {
    case CASINO_FILTER_NAME.KWIFF_PICKS:
      return intl.formatMessage({ id: 'common.domain_picks' }, { domain });
    case CASINO_FILTER_NAME.HOME_MOST_POPULAR:
      return intl.formatMessage({ id: 'casino_filters.home_most_popular' });
    case CASINO_FILTER_NAME.MOST_POPULAR:
      return intl.formatMessage({ id: 'common.most_popular' });
    case CASINO_FILTER_NAME.ALL_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.all_slots' });
    case CASINO_FILTER_NAME.ALL_TABLE_GAMES:
      return intl.formatMessage({ id: 'casino_filters.all_table_games' });
    case CASINO_FILTER_NAME.ALL_LIVE_CASINO_GAMES:
      return intl.formatMessage({ id: 'casino_filters.all_live_casino_games' });
    case CASINO_FILTER_NAME.WE_HAVE_GOT_JACKPOT_MAD:
      return intl.formatMessage({ id: 'casino_filters.we_have_got_jackpot_mad' });
    case CASINO_FILTER_NAME.NEW_GAMES_WE_LOVE:
      return intl.formatMessage({ id: 'casino_filters.new_games_we_love' });
    case CASINO_FILTER_NAME.NEW_AT_KWIFF:
      return intl.formatMessage({ id: 'casino_filters.new_at_kwiff' }, { domain });
    case CASINO_FILTER_NAME.SCHEDULED:
      return intl.formatMessage({ id: 'casino_filters.scheduled' });
    case CASINO_FILTER_NAME.INSTANT:
      return intl.formatMessage({ id: 'casino_filters.instant' });
    case CASINO_FILTER_NAME.SPORTS:
      return intl.formatMessage({ id: 'common.sports' });
    case CASINO_FILTER_NAME.IT_IS_KWIFFMAS:
      return intl.formatMessage({ id: getIntlCasinoFiltersItIsKwiffmasTextKey() });
    case CASINO_FILTER_NAME.MEGAWAYS_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.megaways_slots' });
    case CASINO_FILTER_NAME.EASTER:
      return intl.formatMessage({ id: 'casino_filters.easter' });
    case CASINO_FILTER_NAME.IT_IS_SHOW_TIME:
      return intl.formatMessage({ id: 'casino_filters.it_is_show_time' });
    case CASINO_FILTER_NAME.FANCY_THE_KWIFF_EXPERIENCE:
      return intl.formatMessage({ id: 'casino_filters.fancy_the_kwiff_experience' }, { domain });
    case CASINO_FILTER_NAME.NEW_AT_KWIFF_LIVE_CASINO:
      return intl.formatMessage({ id: 'casino_filters.new_at_kwiff_live_casino' }, { domain });
    case CASINO_FILTER_NAME.SCRATCH_AND_REVEAL:
      return intl.formatMessage({ id: 'casino_filters.scratch_and_reveal' });
    case CASINO_FILTER_NAME.IT_IS_A_JUNGLE_VIBE:
      return intl.formatMessage({ id: 'casino_filters.it_is_a_jungle_vibe' });
    case CASINO_FILTER_NAME.VIRTUAL_FOOTBALL:
      return intl.formatMessage({ id: 'casino_filters.virtual_football' });
    case CASINO_FILTER_NAME.NO_LIMIT_WORLD:
      return intl.formatMessage({ id: 'casino_filters.no_limit_world' });
    case CASINO_FILTER_NAME.MEGA_DROPS:
      return intl.formatMessage({ id: 'casino_filters.mega_drops' });
    case CASINO_FILTER_NAME.NEW_GAMES:
      return intl.formatMessage({ id: 'casino_filters.new_games' });
    case CASINO_FILTER_NAME.FEATURED_STUDIO:
      return intl.formatMessage({ id: 'casino_filters.featured_studio' });
    case CASINO_FILTER_NAME.EVEN_MORE_KWIFFMAS_SLOTS:
      return intl.formatMessage({ id: getIntlCasinoFiltersEvenMoreKwiffmasSlotsTextKey() });
    case CASINO_FILTER_NAME.KWIFFMAS:
      return intl.formatMessage({ id: getIntlCasinoFiltersKwiffmasTextKey() });
    case CASINO_FILTER_NAME.PROGRESSIVE_JACKPOTS:
      return intl.formatMessage({ id: 'casino_filters.progressive_jackpots' });
    case CASINO_FILTER_NAME.THUNDERKICKS_FINEST:
      return intl.formatMessage({ id: 'casino_filters.thunderkicks_finest' });
    case CASINO_FILTER_NAME.SCRATCHCARDS:
      return intl.formatMessage({ id: 'casino_filters.scratchcards' });
    case CASINO_FILTER_NAME.LIVE_CASINO:
      return intl.formatMessage({ id: 'common.live_casino' });
    case CASINO_FILTER_NAME.TABLE_GAMES:
      return intl.formatMessage({ id: 'common.table_games' });
    case CASINO_FILTER_NAME.GAME_SHOWS:
      return intl.formatMessage({ id: 'casino_filters.game_shows' });
    case CASINO_FILTER_NAME.KWIFFS_JOKERS:
      return intl.formatMessage({ id: 'casino_filters.kwiffs_jokers' }, { domain });
    case CASINO_FILTER_NAME.VIKING_RAIDERS:
      return intl.formatMessage({ id: 'casino_filters.viking_raiders' });
    case CASINO_FILTER_NAME.ALL_VIRTUAL_SPORTS:
      return intl.formatMessage({ id: 'casino_filters.all_virtual_sports' });
    case CASINO_FILTER_NAME.LIVE_ON_THE_WILD_SIDE:
      return intl.formatMessage({ id: 'casino_filters.live_on_the_wild_side' });
    case CASINO_FILTER_NAME.CLASSIC_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.classic_slots' });
    case CASINO_FILTER_NAME.THE_LUCKY_ORCHARD:
      return intl.formatMessage({ id: 'casino_filters.the_lucky_orchard' });
    case CASINO_FILTER_NAME.OUT_OF_THE_WORLD_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.out_of_this_world_slots' });
    case CASINO_FILTER_NAME.MAGICAL_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.magical_slots' });
    case CASINO_FILTER_NAME.ANCIENT_EGYPT:
      return intl.formatMessage({ id: 'casino_filters.ancient_egypt' });
    case CASINO_FILTER_NAME.ANIMAL_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.animal_slots' });
    case CASINO_FILTER_NAME.ADVENTURE_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.adventure_slots' });
    case CASINO_FILTER_NAME.SLOTS_FROM_BEYOND_THE_GREAT_WALL:
      return intl.formatMessage({ id: 'casino_filters.slots_from_beyond_the_great_wall' });
    case CASINO_FILTER_NAME.THE_FAR_EAST:
      return intl.formatMessage({ id: 'casino_filters.the_far_east' });
    case CASINO_FILTER_NAME.CITY_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.city_slots' });
    case CASINO_FILTER_NAME.MONSTERS_UNLEASHED:
      return intl.formatMessage({ id: 'casino_filters.monsters_unleashed' });
    case CASINO_FILTER_NAME.MEDIEVAL_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.medieval_slots' });
    case CASINO_FILTER_NAME.MAGICAL_CREATURES:
      return intl.formatMessage({ id: 'casino_filters.magical_creatures' });
    case CASINO_FILTER_NAME.CHRISTMAS_DAILY_FREE_SPIN_TOURNAMENT:
      return intl.formatMessage({ id: 'casino_filters.christmas_daily_free_spin_tournament' });
    case CASINO_FILTER_NAME.THE_BIG_SCREEN:
      return intl.formatMessage({ id: 'casino_filters.the_big_screen' });
    case CASINO_FILTER_NAME.MYTHICAL_CREATURES:
      return intl.formatMessage({ id: 'casino_filters.mythical_creatures' });
    case CASINO_FILTER_NAME.HEROES_AND_VILLAINS:
      return intl.formatMessage({ id: 'casino_filters.heroes_and_villains' });
    case CASINO_FILTER_NAME.XMAS_TOURNAMENT:
      return intl.formatMessage({ id: 'casino_filters.xmas_tournament' });
    case CASINO_FILTER_NAME.TWENTY_TWENTYONE_PRIZE_DROP:
      return intl.formatMessage({ id: 'casino_filters.twenty_twentyone_prize_drop' });
    case CASINO_FILTER_NAME.A_THOUSAND_POUNDS_MULTIGAME_TOURNAMENT:
      return intl.formatMessage({ id: 'casino_filters.a_thousand_pounds_multigame_tournament' });
    case CASINO_FILTER_NAME.MEGAWAYS:
      return intl.formatMessage({ id: 'casino_filters.megaways' });
    case CASINO_FILTER_NAME.HEATING_UP_WINTER:
      return intl.formatMessage({ id: 'casino_filters.heating_up_winter' });
    case CASINO_FILTER_NAME.HAPPY_KWIFFENTINES:
      return intl.formatMessage({ id: getIntlCasinoFiltersHappyKwiffentinesTextKey() });
    case CASINO_FILTER_NAME.HAPPY_CHINESE_NEW_YEAR_EXCLAMATION:
      return intl.formatMessage({ id: 'casino_filters.happy_chinese_new_year_exclamation' });
    case CASINO_FILTER_NAME.ST_PATRICKS_DAY_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.st_patricks_day_slots' });
    case CASINO_FILTER_NAME.CHELTENHAM:
      return intl.formatMessage({ id: 'casino_filters.cheltenham' });
    case CASINO_FILTER_NAME.WEEKLY_TOURNAMENT:
      return intl.formatMessage({ id: 'casino_filters.weekly_tournament' });
    case CASINO_FILTER_NAME.WOWPOT:
      return intl.formatMessage({ id: 'casino_filters.wowpot' });
    case CASINO_FILTER_NAME.MEGA_MOOLAH:
      return intl.formatMessage({ id: 'casino_filters.mega_moolah' });
    case CASINO_FILTER_NAME.WEEKLY_MULTI_GAME_TOURNAMENT:
      return intl.formatMessage({ id: 'casino_filters.weekly_multi_game_tournament' });
    case CASINO_FILTER_NAME.REELERCOASTER:
      return intl.formatMessage({ id: 'casino_filters.reelercoaster' });
    case CASINO_FILTER_NAME.KWIFFOWEEN:
      return intl.formatMessage({ id: getIntlCasinoFiltersKwiffoweenTextKey() });
    case CASINO_FILTER_NAME.ROULETTE:
      return intl.formatMessage({ id: 'casino_filters.roulette' });
    case CASINO_FILTER_NAME.BLACKJACK:
      return intl.formatMessage({ id: 'casino_filters.blackjack' });
    case CASINO_FILTER_NAME.POKER:
      return intl.formatMessage({ id: 'casino_filters.poker' });
    case CASINO_FILTER_NAME.BACCARAT:
      return intl.formatMessage({ id: 'casino_filters.baccarat' });
    case CASINO_FILTER_NAME.GOLDEN_GAMES:
      return intl.formatMessage({ id: 'casino_filters.golden_games' });
    case CASINO_FILTER_NAME.MULTI_HAND_GAMES:
      return intl.formatMessage({ id: 'casino_filters.multi_hand_games' });
    case CASINO_FILTER_NAME.EUROPEAN_GAMES:
      return intl.formatMessage({ id: 'casino_filters.european_games' });
    case CASINO_FILTER_NAME.FIVE_CARD_DRAW:
      return intl.formatMessage({ id: 'casino_filters.five_card_draw' });
    case CASINO_FILTER_NAME.AMERICAN_TABLES:
      return intl.formatMessage({ id: 'casino_filters.american_tables' });
    case CASINO_FILTER_NAME.VEGAS_GAMES:
      return intl.formatMessage({ id: 'casino_filters.vegas_games' });
    case CASINO_FILTER_NAME.FIRST_PERSON_GAMES:
      return intl.formatMessage({ id: 'casino_filters.first_person_games' });
    case CASINO_FILTER_NAME.TABLES_FROM_AROUND_THE_WORLD:
      return intl.formatMessage({ id: 'casino_filters.tables_from_around_the_world' });
    case CASINO_FILTER_NAME.SPEED_BLACKJACK:
      return intl.formatMessage({ id: 'casino_filters.speed_blackjack' });
    case CASINO_FILTER_NAME.CLASSIC_BLACKJACK:
      return intl.formatMessage({ id: 'casino_filters.classic_blackjack' });
    case CASINO_FILTER_NAME.DELUXE_TABLES:
      return intl.formatMessage({ id: 'casino_filters.deluxe_tables' });
    case CASINO_FILTER_NAME.VIP_TABLES:
      return intl.formatMessage({ id: 'casino_filters.vip_tables' });
    case CASINO_FILTER_NAME.BLACKJACK_SILVER:
      return intl.formatMessage({ id: 'casino_filters.blackjack_silver' });
    case CASINO_FILTER_NAME.SALON_PRIVE:
      return intl.formatMessage({ id: 'casino_filters.salon_prive' });
    case CASINO_FILTER_NAME.VIRTUAL_RACING:
      return intl.formatMessage({ id: 'casino_filters.virtual_racing' });
    case CASINO_FILTER_NAME.DIAMONDS_ARE_FOREVER:
      return intl.formatMessage({ id: 'casino_filters.diamonds_are_forever' });
    case CASINO_FILTER_NAME.CLOWNING_AROUND:
      return intl.formatMessage({ id: 'casino_filters.clowning_around' });
    case CASINO_FILTER_NAME.HIGH_SOCIETY:
      return intl.formatMessage({ id: 'casino_filters.high_society' });
    case CASINO_FILTER_NAME.GOLDEN_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.golden_slots' });
    case CASINO_FILTER_NAME.ANCIENT_BOOKS:
      return intl.formatMessage({ id: 'casino_filters.ancient_books' });
    case CASINO_FILTER_NAME.MYTHS_AND_LEGENDS:
      return intl.formatMessage({ id: 'casino_filters.myths_and_legends' });
    case CASINO_FILTER_NAME.KINGS_AND_QUEENS:
      return intl.formatMessage({ id: 'casino_filters.kings_and_queens' });
    case CASINO_FILTER_NAME.THE_AMERICAS:
      return intl.formatMessage({ id: 'casino_filters.the_americas' });
    case CASINO_FILTER_NAME.SLOT_FAIRIES:
      return intl.formatMessage({ id: 'casino_filters.slot_fairies' });
    case CASINO_FILTER_NAME.THE_RANCH:
      return intl.formatMessage({ id: 'casino_filters.the_ranch' });
    case CASINO_FILTER_NAME.NEON_LIGHTS:
      return intl.formatMessage({ id: 'casino_filters.neon_lights' });
    case CASINO_FILTER_NAME.RICHES:
      return intl.formatMessage({ id: 'casino_filters.riches' });
    case CASINO_FILTER_NAME.TURN_IT_UP:
      return intl.formatMessage({ id: 'casino_filters.turn_it_up' });
    case CASINO_FILTER_NAME.DIVINE_REWARDS:
      return intl.formatMessage({ id: 'casino_filters.divine_rewards' });
    case CASINO_FILTER_NAME.WHAT_IS_ON_TONINGHT:
      return intl.formatMessage({ id: 'casino_filters.what_is_on_tonight' });
    case CASINO_FILTER_NAME.THE_WITCHES:
      return intl.formatMessage({ id: 'casino_filters.the_witches' });
    case CASINO_FILTER_NAME.KWIFFS_LIBRARY:
      return intl.formatMessage({ id: 'casino_filters.kwiffs_library' }, { domain });
    case CASINO_FILTER_NAME.POWERFUL_WOMEN:
      return intl.formatMessage({ id: 'casino_filters.powerful_women' });
    case CASINO_FILTER_NAME.DEEP_IN_THE_FOREST:
      return intl.formatMessage({ id: 'casino_filters.deep_in_the_forest' });
    case CASINO_FILTER_NAME.WILD_WEST:
      return intl.formatMessage({ id: 'casino_filters.wild_west' });
    case CASINO_FILTER_NAME.ITALIAN_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.italian_slots' });
    case CASINO_FILTER_NAME.THE_ROMANS:
      return intl.formatMessage({ id: 'casino_filters.the_romans' });
    case CASINO_FILTER_NAME.IRISH_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.irish_slots' });
    case CASINO_FILTER_NAME.MEXICAN_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.mexican_slots' });
    case CASINO_FILTER_NAME.ISLAND_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.island_slots' });
    case CASINO_FILTER_NAME.BEACH_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.beach_slots' });
    case CASINO_FILTER_NAME.SUMMER_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.summer_slots' });
    case CASINO_FILTER_NAME.FAIRYTALE_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.fairytale_slots' });
    case CASINO_FILTER_NAME.BEST_OF_HACKSAW:
      return intl.formatMessage({ id: 'casino_filters.best_of_hacksaw' });
    case CASINO_FILTER_NAME.FUTURISTIC_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.futuristic_slots' });
    case CASINO_FILTER_NAME.PACIFIC_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.pacific_slots' });
    case CASINO_FILTER_NAME.MYSTERY_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.mystery_slots' });
    case CASINO_FILTER_NAME.WINTER_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.winter_slots' });
    case CASINO_FILTER_NAME.COPS_AND_ROBBERS:
      return intl.formatMessage({ id: 'casino_filters.cops_and_robbers' });
    case CASINO_FILTER_NAME.PIRATE_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.pirate_slots' });
    case CASINO_FILTER_NAME.ON_SAFARI:
      return intl.formatMessage({ id: 'casino_filters.on_safari' });
    case CASINO_FILTER_NAME.DEEP_SEA_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.deep_sea_slots' });
    case CASINO_FILTER_NAME.JEWELS:
      return intl.formatMessage({ id: 'casino_filters.jewels' });
    case CASINO_FILTER_NAME.ANCIENT_GREEKS:
      return intl.formatMessage({ id: 'casino_filters.ancient_greeks' });
    case CASINO_FILTER_NAME.PRECIOUS_STONES:
      return intl.formatMessage({ id: 'casino_filters.precious_stones' });
    case CASINO_FILTER_NAME.SWEET_SLOTS:
      return intl.formatMessage({ id: 'casino_filters.sweet_slots' });
    case CASINO_FILTER_NAME.DEMONS:
      return intl.formatMessage({ id: 'casino_filters.demons' });
    case CASINO_FILTER_NAME.THE_DEAD_RISING:
      return intl.formatMessage({ id: 'casino_filters.the_dead_rising' });
    case CASINO_FILTER_NAME.COLD_HARD_CASH:
      return intl.formatMessage({ id: 'casino_filters.cold_hard_cash' });
    case CASINO_FILTER_NAME.PRINCESSES:
      return intl.formatMessage({ id: 'casino_filters.princesses' });
    case CASINO_FILTER_NAME.FEELING_LUCKY:
      return intl.formatMessage({ id: 'casino_filters.feeling_lucky' });
    case CASINO_FILTER_NAME.TREASURE:
      return intl.formatMessage({ id: 'casino_filters.treasure' });
    case CASINO_FILTER_NAME.FROZEN_WASTELAND:
      return intl.formatMessage({ id: 'casino_filters.frozen_wasteland' });
    case CASINO_FILTER_NAME.ON_THE_FARM:
      return intl.formatMessage({ id: 'casino_filters.on_the_farm' });
    case CASINO_FILTER_NAME.THE_WOLF_PACK:
      return intl.formatMessage({ id: 'casino_filters.the_wolf_pack' });
    case CASINO_FILTER_NAME.VAMPIRES:
      return intl.formatMessage({ id: 'casino_filters.vampires' });
    case CASINO_FILTER_NAME.STORMS_BREWING:
      return intl.formatMessage({ id: 'casino_filters.storms_brewing' });
    case CASINO_FILTER_NAME.KWIFFS_TOP_TABLES:
      return intl.formatMessage({ id: 'casino_filters.kwiffs_top_tables' }, { domain });
    case CASINO_FILTER_NAME.MEGA_BALL:
      return intl.formatMessage({ id: 'casino_filters.mega_ball' });
    case CASINO_FILTER_NAME.HAPPY_CHINESE_NEW_YEAR:
      return intl.formatMessage({ id: 'casino_filters.happy_chinese_new_year' });
    case CASINO_FILTER_NAME.INFINITY_REELS:
      return intl.formatMessage({ id: 'casino_filters.infinity_reels' });
    case CASINO_FILTER_NAME.SCRATCH_CARDS:
      return intl.formatMessage({ id: 'casino_filters.scratch_cards' });
    case CASINO_FILTER_NAME.BLACK_JACK:
      return intl.formatMessage({ id: 'casino_filters.black_jack' });
    case CASINO_FILTER_NAME.RECENTLY_PLAYED:
      return intl.formatMessage({ id: 'casino_filters.recently_played' });
    case CASINO_FILTER_NAME.NEW:
      return intl.formatMessage({ id: 'common.new' });
    default:
      return filterName;
  }
};
